// src/pages/ITSolutions.tsx

import React, { useEffect, useState } from "react";
import styled from "styled-components";
import InquireComponent from "../components/Inquire.tsx";
import MobileHomepageEnquiry from "../components/MobileHomepageEnquiry.tsx";
import Marquee from "react-fast-marquee";
import MobileTech from "../components/MobileTech.tsx";

const Container = styled.div`
  width: auto;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;

  @media (max-width: 1550px) {
    width: auto;
  }
`;

const CustomContainer = styled.div<{
  padding?: string;
  marginTop?: string;
  width?: string;
  height?: string;
  backgroundColor?: string;
  borderRadius?: string;
  display?: string;
  alignItems?: string;
  justifyContent?: string;
  flexDirection?: string;
  gap?: string;
  border?: string;

  // 반응형 옵션
  mobilePadding?: string;
  mobileMargin?: string;
  mobileWidth?: string;
  mobileHeight?: string;
  mobileBackgroundColor?: string;
  mobileBorderRadius?: string;
  mobileDirection?: string;
  mobileGap?: string;
  mobileMarginTop?: string;
}>`
  display: ${({ display = "flex" }) => display};
  padding: ${({ padding = "0px 0px 0px 0px" }) => padding};
  margin-top: ${({ marginTop = "0" }) => marginTop};
  width: ${({ width = "100%" }) => width};
  height: ${({ height = "auto" }) => height};
  background-color: ${({ backgroundColor = "transparent" }) => backgroundColor};
  border-radius: ${({ borderRadius = "0" }) => borderRadius};
  border: ${({ border = "none" }) => border};
  align-items: ${({ alignItems = "center" }) => alignItems};
  justify-content: ${({ justifyContent = "center" }) => justifyContent};
  flex-direction: ${({ flexDirection = "row" }) => flexDirection};
  gap: ${({ gap = "0" }) => gap};
  box-sizing: border-box;

  @media (max-width: 1550px) {
    padding: ${({ mobilePadding }) => mobilePadding || "inherit"};
    margin: ${({ mobileMargin }) => mobileMargin || "inherit"};
    width: ${({ mobileWidth }) => mobileWidth || "inherit"};
    height: ${({ mobileHeight }) => mobileHeight || "inherit"};
    background-color: ${({ mobileBackgroundColor }) =>
      mobileBackgroundColor || "inherit"};
    border-radius: ${({ mobileBorderRadius }) =>
      mobileBorderRadius || "inherit"};
    flex-direction: ${({ mobileDirection }) => mobileDirection || "inherit"};
    gap: ${({ mobileGap }) => mobileGap || "inherit"};
    margin-top: ${({ mobileMarginTop }) => mobileMarginTop || "inherit"};
  }
`;

const Text = styled.div<{
  marginTop?: string;
  color?: string;
  fontWeight?: string | number;
  fontSize?: string;
  textAlign?: string;

  mobileMarginTop?: string; // 모바일 전용 margin-top
  mobileFontSize?: string; // 모바일 전용 font-size
  mobileMarginBottom?: string; // 모바일 전용 margin-bottom
}>`
  display: flex;
  margin-top: ${({ marginTop = "0" }) => marginTop};
  color: ${({ color = "white" }) => color};
  font-weight: ${({ fontWeight = "bold" }) => fontWeight};
  font-size: ${({ fontSize = "32px" }) => fontSize};
  font-family: "Pretendard";
  text-align: ${({ textAlign = "center" }) => textAlign};
  white-space: pre-wrap;
  word-break: break-word;

  @media (max-width: 1550px) {
    font-size: ${({ mobileFontSize }) => mobileFontSize || "inherit"};
    margin-top: ${({ mobileMarginTop }) => mobileMarginTop || "inherit"};
    margin-bottom: ${({ mobileMarginBottom }) =>
      mobileMarginBottom || "inherit"};
  }
`;

const Icon = styled.img<{
  width: string;
  height: string;
  marginBottom?: string;
  borderRadius?: string;
  border?: string;
  mobileWidth?: string;
  mobileHeight?: string;
  mobileMargin?: string;
}>`
  width: ${(props) => props.width}; // width 설정
  height: ${(props) => props.height}; // height 설정
  margin-bottom: ${(props) => props.marginBottom}; // height 설정
  border-radius: ${(props) => props.borderRadius}; // border-radius 설정
  border: ${(props) => props.border}; // border 설정
  @media (max-width: 1550px) {
    margin-bottom: 5px;
    height: ${(props) => props.mobileHeight};
    width: ${(props) => props.mobileWidth};
    margin: ${(props) => props.mobileMargin};
  }
`;
// 카드 컴포넌트
const CardComponent = ({
  data,
  key,
}: {
  data: { icon: string; title: string; description: string };
  key: number;
}) => {
  return (
    <CustomContainer
      flexDirection="row"
      width="717px"
      height="183px"
      borderRadius="10px"
      border="1.6px solid #393939"
      gap="20px"
      padding="0px 0px 0px 40px"
      justifyContent="flex-start"
      mobileWidth="333px"
      mobileHeight="auto"
      mobileDirection="column"
      mobilePadding="20px 20px 20px 20px"
      mobileGap="5px"
      mobileBorderRadius="10px"
    >
      <Icon
        src={data.icon}
        width="223px"
        height="135px"
        borderRadius="10px"
        border="1.6px solid #393939"
        mobileWidth="285px"
        mobileHeight="135px"
      />
      <CustomContainer
        flexDirection="column"
        gap="5px"
        width="auto"
        height="auto"
        alignItems="flex-start"
        textAlign="left"
        justifyContent="flex-start"
        mobileheight="auto"
      >
        <Text
          fontSize="22px"
          fontWeight="Bold"
          color="#00E186"
          mobileFontSize="25px"
        >
          {data.title}
        </Text>
        <Text
          display="flex"
          fontSize="16px"
          fontWeight="Regular"
          textAlign="left"
          width="100%"
          mobileFontSize="17px"
        >
          {data.description}
        </Text>
      </CustomContainer>
    </CustomContainer>
  );
};

// ProcessCardContainer: 직사각형 카드의 컨테이너
const ProcessCardContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative; // 동그라미가 직사각형에 겹치도록 하기 위해
  width: 800px;
  height: 160px;
  border-radius: 10px;
  background-color: #2f2f2f;
  align-items: center;
  padding: 50px;
  box-sizing: border-box;
  margin-top: 30px;
`;

// CardContent: 타이틀과 서브타이틀을 담는 컨테이너
const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  text-align: left;
`;

// Circle: 직사각형의 왼쪽에 배치될 동그라미 스타일
const Circle = styled.div<{ number: string }>`
  position: absolute;
  left: -20px; // 직사각형의 왼쪽에 위치하도록 설정
  top: 50%; // 세로 중앙 정렬
  transform: translateY(-50%); // 세로 중앙 정렬
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #0d9ae5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: bold;
  font-size: 18px;
`;

// ProcessCard: 각 카드를 렌더링하는 컴포넌트
const ProcessCard = ({
  title,
  subtitle,
  number,
}: {
  title: string;
  subtitle: string;
  number: string;
}) => (
  <ProcessCardContainer>
    <Circle number={number}>{number}</Circle> {/* 동그라미에 번호 넣기 */}
    <CardContent>
      <Text color="#0D9AE5" fontSize="22px">
        {title}
      </Text>
      <Text fontSize="16px" textAlign="left">
        {subtitle}
      </Text>
    </CardContent>
  </ProcessCardContainer>
);

/*모바일 프로세스카드*/
const MobileProcessCardContainer = styled.div`
  position: relative; /* 원을 카드 위에 겹치게 만들기 위해 */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 300px;
  height: auto;
  border-radius: 10px;
  background-color: #2f2f2f;
  margin-top: 30px;
  padding: 20px;
`;

const MobileCircle = styled.div<{ number: number }>`
  position: absolute;
  top: 0; /* 상단에 배치 */
  left: 50%; /* 가운데 정렬 */
  transform: translate(-50%, -50%); /* 중앙 정렬 + 절반 걸치게 */
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #0d9ae5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-weight: bold;
  font-size: 18px;
`;

const MobileCardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: center;
  margin-top: 10px; /* 원과 카드 내용 간격 */
  gap: 5px;
`;

const MobileProcessCard = ({
  title,
  subtitle,
  number,
}: {
  title: string;
  subtitle: string;
  number: string;
}) => (
  <MobileProcessCardContainer>
    <MobileCircle number={number}>{number}</MobileCircle>{" "}
    {/* 원이 중앙 상단에 위치 */}
    <MobileCardContent>
      <Text color="#0D9AE5" mobileFontSize="23px" textAlign="left">
        {title}
      </Text>
      <Text fontSize="16px" textAlign="left">
        {subtitle}
      </Text>
    </MobileCardContent>
  </MobileProcessCardContainer>
);

function ITsolutions() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 1550);
    handleResize(); // 초기 화면 크기 체크
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cardData = [
    {
      icon: "/images/itsolutions_icon/icon1.png",
      title: "웹 개발",
      description:
        "관리를 위한 맞춤형 웹 플랫폼 구축\n원활한 소통을 위한 통합 커뮤니케이션 플랫폼 개발\n데이터 분석 및 시각화 플랫폼 개발",
    },
    {
      icon: "/images/itsolutions_icon/icon2.png",
      title: "홈페이지 제작",
      description:
        "특성에 맞는 맞춤형 반응형 웹사이트 디자인 \nSEO 최적화 및 마케팅 효과를 고려한 구조 설계 \n환자 편의성을 높인 직관적인 UI/UX 구현 \niOS 및 Android 플랫폼 앱 개발",
    },
    {
      icon: "/images/itsolutions_icon/icon3.png",
      title: "앱 개발",
      description:
        "특성에 맞는 맞춤형 반응형 웹사이트 디자인\nSEO 최적화 및 마케팅 효과를 고려한 구조 설계\n환자 편의성을 높인 직관적인 UI/UX 구현\niOS 및 Android 플랫폼 앱 개발",
    },
  ];

  const solutionData = [
    {
      icon: "/images/itsolutions_icon/2_icon1.png",
      title: "기술컨설팅",
      description:
        "서비스보다 높은 기술력이 필요한 개발 플랫폼을\n만든 전문가들이 최적의 IT 컨설팅을 제공합니다.",
    },
    {
      icon: "/images/itsolutions_icon/2_icon2.png",
      title: "탑 티어 개발자와 전담 매니저",
      description:
        "국내 탑티어 기술 회사의 개발력과\n전담 프로젝트 매니저로 팀을 구성하여\n매끄러운 개발 경험을 보여드립니다.",
    },
    {
      icon: "/images/itsolutions_icon/2_icon3.png",
      title: "합리적 가격",
      description:
        "자체 개발자를 통해 합리적인 비용,\n검증된 최신 기술 스택의 개발 서비스를 느껴보세요!",
    },
  ];

  const processData = [
    {
      number: "01",
      title: "프로젝트 요구사항 분석",
      description:
        "미팅을 통해 플랫폼 개발 전문가들이 프로젝트의 목표와 요구사항을 섬세하게 파악합니다.\n요구사항을 기반으로 기능별 화면 구성과 시스템을 설계하고 일정 및 예산을 협의해요",
    },
    {
      number: "02",
      title: "디자인",
      description:
        "프로젝트의 주요 이용자들에게 최적화된 UI/UX를 기반으로 디자인 작업을 수행합니다\n디자인은 Figma를 통해 진행되며 진행 사항을 실시간으로 하실 수 있어요.",
    },
    {
      number: "03",
      title: "개발",
      description:
        "국내 탑티어 기술 회사 출신 개발자들이 프로젝트를 만들기 시작합니다.\n 24시간 전담 프로젝트 매너지를 통해 매주의 진행 사항과 일정을 확인할 수 있어요.",
    },
    {
      number: "04",
      title: "테스트",
      description:
        "자체 Quality Assurance 시스템을 통해 꼼꼼한 테스트를 수행합니다.\n다양한 개발 경흠을 통해 프로젝트 성격별 맞춤형 테스트로 프로젝트의 완성도를 높여요.",
    },
    {
      number: "05",
      title: "출시",
      description:
        "테스트가 완료되면 프로젝트를 출시합니다.\n출시 이후 프로젝트가 안정화 될 때까지 제한없이 하자보수를 해드려요.\n45일이 지난 이후 프로젝트가 안정적으로 구동되면 프로젝트를 마무리해요.",
    },
  ];

  const devIconData = [
    { icon: "/images/itsolutions_icon/dev_icon/react 1.png", title: "React" },
    { icon: "/images/itsolutions_icon/dev_icon/next 1.png", title: "Next.js" },
    { icon: "/images/itsolutions_icon/dev_icon/vue 1.png", title: "Vue.js" },
    {
      icon: "/images/itsolutions_icon/dev_icon/flutter 1.png",
      title: "Flutter",
    },
    { icon: "/images/itsolutions_icon/dev_icon/unity 1.png", title: "Unity" },
    {
      icon: "/images/itsolutions_icon/dev_icon/android 1.png",
      title: "Android",
    },
    { icon: "/images/itsolutions_icon/dev_icon/apple 1.png", title: "Apple" },
    {
      icon: "/images/itsolutions_icon/dev_icon/spring 1.png",
      title: "Spring Boot",
    },
    { icon: "/images/itsolutions_icon/dev_icon/go 2.png", title: "Golang" },
    { icon: "/images/itsolutions_icon/dev_icon/py 1.png", title: "Python" },
    { icon: "/images/itsolutions_icon/dev_icon/aws 2.png", title: "AWS" },
  ];

  const extendedData = [...devIconData, ...devIconData];

  return (
    <Container width="100%">
      {isMobile ? (
        <Text
          mobileMarginTop="30px"
          mobileFontSize="27px"
          mobileMarginBottom="30px"
        >
          클라이언트가 구상하는
          <br />
          서비스를 슬라임이 <br />
          구현해 냅니다.
        </Text>
      ) : (
        <Text marginTop="100px" fontSize="32px">
          클라이언트가 구상하는 서비스를 슬라임이 구현해 냅니다.
        </Text>
      )}
      {isMobile ? (
        <CustomContainer
          flexDirection="column"
          mobileMargin="20px 0px 0px 0px"
          gap="20px"
          mobileGap="20px"
        >
          {cardData.map((data, index) => (
            <CardComponent key={index} data={data} />
          ))}
        </CustomContainer>
      ) : (
        <CustomContainer flexDirection="column" marginTop="40px" gap="20px">
          {cardData.map((data, index) => (
            <CardComponent key={index} data={data} />
          ))}
        </CustomContainer>
      )}
      <Text
        marginTop="100px"
        fontSize="32px"
        mobileFontSize="27px"
        mobileMarginTop="50px"
      >
        IT 솔루션
      </Text>
      <CustomContainer
        flexDirection="row"
        width="1300px"
        gap="20px"
        marginTop="40px"
        mobileflexDirection="column"
        mobileWidth="333px"
        mobileGap="20px"
      >
        {solutionData.map((data, index) => (
          <CustomContainer
            flexDirection="column"
            gap="10px"
            mobileWidth="375px"
            mobileHeight="auto"
            mobileGap="5px"
            style={{
              borderRight:
                !isMobile && index < solutionData.length - 1
                  ? "1px solid #353535"
                  : "none",
              paddingRight: !isMobile ? "20px" : "0",
            }}
          >
            <Icon
              src={data.icon}
              width="100px"
              height="100px"
              mobileWidth="100px"
              mobileHeight="100px"
            ></Icon>
            <Text
              fontSize="22px"
              fontWeight="Bold"
              color="#ffffff"
              mobileFontSize="24px"
            >
              {data.title}
            </Text>
            <Text
              fontSize="16px"
              fontWeight="Regular"
              color="#ffffff"
              mobileFontSize="17px"
            >
              {data.description}
            </Text>
          </CustomContainer>
        ))}
      </CustomContainer>
      <Text
        marginTop="100px"
        fontSize="32px"
        mobileFontSize="27px"
        mobileMarginTop="100px"
      >
        진행 프로세스
      </Text>
      {isMobile
        ? processData.map((data, index) => (
            <MobileProcessCard
              title={data.title}
              subtitle={data.description}
              number={data.number}
            />
          ))
        : processData.map((data, index) => (
            <ProcessCard
              title={data.title}
              subtitle={data.description}
              number={data.number}
            />
          ))}
      <Text
        marginTop="100px"
        fontSize="32px"
        mobileFontSize="27px"
        mobileMarginTop="100px"
      >
        최신 기술 스택으로 {isMobile ? <br /> : null} 클라이언트가 원하는
        서비스를 {isMobile ? <br /> : null} 탄탄하게 개발합니다.
      </Text>
      {isMobile ? (
        <MobileTech></MobileTech>
      ) : (
        <CustomContainer
          flexDirection="row"
          gap="10px"
          marginTop="30px"
          width="1430px"
        >
          {devIconData.map((data) => (
            <CustomContainer
              key={data.title}
              flexDirection="column"
              gap="10px"
              alignItems="center"
              justifyContent="center"
            >
              <Icon src={data.icon} width="60px" height="60px"></Icon>
              <Text fontSize="20px" fontWeight="Bold" color="#ffffff">
                {data.title}
              </Text>
            </CustomContainer>
          ))}
        </CustomContainer>
      )}
      <Text
        marginTop="100px"
        fontSize="32px"
        mobileFontSize="27px"
        mobileMarginTop="50px"
      >
        다양한 기업들이 슬라임을{isMobile ? <br /> : null} 신뢰하고 있습니다.
      </Text>
      <InquireComponent isMobile={isMobile} />
    </Container>
  );
}

export default ITsolutions;
